import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Box from '@amzn/meridian/box';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import { GoalDisplay } from './types';
import { formatGoalToString, GoalPage } from './helper';
import { StateContext } from '../../GlobalStateStore';

import { renderUrl, urls } from '../../Util';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import Link from '@amzn/meridian/link';
import { useNavigate } from 'react-router';

export interface GoalCoachingsModalProps {
  isOpen: boolean;
  setIsOpen: any;
  goal: GoalDisplay;
  page: GoalPage;
}

const GoalCoachingsModal: React.FC<GoalCoachingsModalProps> = ({
  isOpen,
  setIsOpen,
  goal,
  page,
}: GoalCoachingsModalProps): React.ReactElement => {
  const intl = useIntl();
  const navigate = useNavigate();

  const navigateToCoachings = (userId: string, coachingID: string) => {
    navigate(
      renderUrl(`${urls.coachingNotes}/${userId}?coachingID=${coachingID}`)
    );
  };
  const globalState = useContext(StateContext);
  const { inspireOptions } = globalState.state;
  const { isTm, requesterUsername, requesterUserID } = inspireOptions.data;

  return (
    <>
      <Modal
        title={intl.formatMessage(
          {
            id: 'cs_perfportal_goal_coachings_header',
            defaultMessage: `Coachings for {displayName}`,
          },
          {
            displayName: goal.associate,
          }
        )}
        open={isOpen}
        onClose={setIsOpen(false)}
        scrollContainer='viewport'
        closeLabel='Close'
        aria-describedby='modal-description'
        width={'809px'}
        bodySpacingInset='450'
      >
        <Box height='fill' width='fill' spacingInset='300'>
          <Column spacingInset='300 none'>
            <Text type='h100' data-testid='goal-label'>
              {formatGoalToString(goal, intl)}
            </Text>
            <Table headerRows={1} showStripes={true}>
              <TableRow>
                <TableCell>
                  <FormattedMessage
                    id='cs_perfportal_coaching_ids'
                    defaultMessage='Coaching IDs'
                  />
                </TableCell>
              </TableRow>
              {goal.coachingIDs?.map(coaching => (
                <TableRow
                  onClick={() =>
                    navigateToCoachings(goal.userID.split(':')[1], coaching)
                  }
                  data-csa-c-type='link'
                  data-csa-c-slot-id={`${page}-goal-setting-check-attached-coaching`}
                  data-csa-c-content-id={`${page}-goal-setting-check-attached-coaching-${goal.userName}-${goal.goalID}-${coaching}`}
                  data-csa-c-tag1={page}
                  data-csa-c-tag2='Goal Setting'
                  data-csa-c-tag3='Goal Setting'
                  data-csa-c-tag4='Goal Attached Coachings'
                  data-csa-c-profile-id={requesterUserID}
                  data-csa-c-username={requesterUsername}
                  data-csa-c-is-tm={isTm}
                >
                  <TableCell>
                    <Link type='secondary'>{coaching}</Link>
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </Column>
          <ModalFooter>
            <Row alignmentHorizontal='end'>
              <Button
                type='primary'
                size='medium'
                minWidth={150}
                onClick={setIsOpen(false)}
                data-testid='close-button'
              >
                <FormattedMessage
                  id='cs_perfportal_done'
                  defaultMessage='Done'
                />
              </Button>
            </Row>
          </ModalFooter>
        </Box>
      </Modal>
    </>
  );
};

export default GoalCoachingsModal;
